import { todayIn, type CalendarDate } from "@pack-it-up/shared";
import { deviceTimezone } from "./timezone.js";

// Date-range formatting moved to @pack-it-up/shared so web and mobile share it.
export { fmtDateRange, fmtTripDates } from "@pack-it-up/shared";

// Relative countdown to a start date in the device timezone, or null if undated.
// Once the end date has passed the trip reads "Past" rather than "Started".
export const countdown = (start?: CalendarDate, end?: CalendarDate, now: Date = new Date()): string | null => {
  if (start === undefined) return null;
  const today = todayIn(deviceTimezone(), now);
  if ((end ?? start) < today) return "Past"; // same anchor the home store uses to group past trips
  const days = Math.round((Date.parse(`${start}T00:00:00`) - Date.parse(`${today}T00:00:00`)) / 86_400_000);
  if (days > 1) return `${days} days to go`;
  if (days === 1) return "Tomorrow";
  if (days === 0) return "Today";
  return "Started";
};
